export const aboutMe = {
  title: "Hello, my name is Idan",
  role: "Full-Stack Developer",
  intro: "experienced in TypeScript and Python programming.",
  abstract:
    "I like to craft solid and scaleable web applications with great user experience.",
  qualifications:
    "I have strong computer networking and troubleshooting skills that help deliver features, find and fix bugs quickly.",
  softSkills:
    "Problem Solver, Team Player, Independent with high attention to detail, Self-learner.",
}
